<template>
  <div v-if="showComponent">
    <vs-card class="mt-4 mb-4">
      <div slot="header">
        <h3>Reparo do Patrimônio</h3>
      </div>
      <div>
        <div class="vx-row">
          <!-- Vistoriador -->
          <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
            <label class="vs-select--label">Vistoriador</label>
            <v-select
              class="selectStyle"
              :options="listVistoriadores"
              name="Vistoriador"
              id="Vistoriador"
              v-model="formReparoVeiculo.idVistoriador"
              label="label"
              :reduce="(item) => item.id"
            ></v-select>
          </div>
        </div>

        <div class="vx-row">
          <!-- Oficina -->
          <div class="vx-col lg:w-1/2 w-full mb-2">
            <label class="vs-select--label">Prestador</label>
            <v-select
              class="selectStyle"
              :options="listOficinas"
              label="nomeFantasia"
              name="Oficina"
              v-model="formReparoVeiculo.idFornecedor"
              @option:selected="updateOficina($event)"
              :reduce="(item) => item.idFornecedor"
            ></v-select>
          </div>
        </div>

        <!-- Detalhes da oficina -->
        <div class="m-5" v-if="oficinaSelecionada">
          <div class="vx-row flex mb-3">
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Nome Fantasia</p>
              {{ oficinaSelecionada.nomeFantasia }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Razão Social</p>
              {{ oficinaSelecionada.razaoSocial }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Celular</p>
              {{ oficinaSelecionada.celular }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Telefone</p>
              {{ oficinaSelecionada.telefone }}
            </div>
          </div>
          <div class="vx-row flex mb-3">
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">CPF/CNPJ</p>
              {{ oficinaSelecionada.cpf_cnpj }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Rua</p>
              {{ oficinaSelecionada.endereco }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Número</p>
              {{ oficinaSelecionada.numero }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Bairro</p>
              {{ oficinaSelecionada.bairro }}
            </div>
          </div>
          <div class="vx-row flex mb-3">
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">CEP</p>
              {{ oficinaSelecionada.cep }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Estado</p>
              {{ oficinaSelecionada.estado }}
            </div>
            <div class="vx-col lg:w-1/4 w-1/2">
              <p class="font-bold">Representante/Contato</p>
              {{ oficinaSelecionada.representanteLegal }}
            </div>
          </div>
        </div>

        <HistoricoOficinas
          :historicoOficinas="formReparoVeiculo.historicos"
          title="Histórico de Prestores Anteriores"
          :modePatrimonio="true"
        />
      </div>
    </vs-card>
  </div>
</template>

<script>
import vSelect from 'vue-select';

import HistoricoOficinas from './../../shared/components/HistoricoOficinas.vue';

export default {
  props: ['formData', 'dominios'],
  watch: {
    formData(value) {
      if (!value.reparoVeiculo) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - REPARO VEICULO DETALHES');
        return;
      }

      this.formReparoVeiculo = Object.assign(
        this.formReparoVeiculo,
        value.reparoVeiculo,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.reparoVeiculo = this.formReparoVeiculo;
    },
  },
  components: {
    vSelect,
    HistoricoOficinas,
  },
  data() {
    return {
      showComponent: true,
      formReparoVeiculo: {
        idVistoriador: null,
        idFornecedor: null,
        historicos: [],
      },
      listOficinas: [],
      listVistoriadores: [],
      oficinaSelecionada: null,
    };
  },
  methods: {
    updateOficina(value) {
      if (!value) {
        this.formReparoVeiculo.idFornecedor = null;
        this.oficinaSelecionada = null;
        return;
      }

      this.formReparoVeiculo.idFornecedor = value.idFornecedor;
      this.oficinaSelecionada = value;
    },
  },
  mounted() {
    if (!this.formData.reparoVeiculo) {
      console.error('ERRO NO CONTRATO DO OBJETO - REPARO VEICULO DETALHES');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.reparoVeiculo = this.formReparoVeiculo;

    this.listOficinas = this.dominios.listOficinas;
    this.listVistoriadores = this.dominios.listVistoriadores;
  },
};
</script>

<style scoped>
.moneyStyle {
  font-size: 1rem !important;
  padding: 0.7rem !important;
}
.inputData > input {
  width: 100%;
}

.selectStyle {
  font-size: 1rem !important;
}
</style>
